import { useMainStore } from "../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive, ref } from "vue";
export default {
  name: "auth",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      tabsIndex: 0,
      caIsAgree: 0,
      comps: [{
        label: "身份认证",
        name: "IdCard"
      }, {
        label: "公司认证",
        name: "CompanyCertification"
      }]
    });
    onMounted(() => {
      caNotify();
    });
    const caNotify = async () => {
      const isAgree = route.query.isAgree;
      const verifyId = route.query.verifyId;
      if (isAgree && verifyId) {
        await globalProperties.$api.caNotify({
          isAgree,
          verifyId
        });
        caIsAgree();
        return;
      }
      caIsAgree();
    };
    const changeTabs = index => {
      data.tabsIndex = index;
    };
    const caIsAgree = async () => {
      var caIsAgree = await globalProperties.$api.caIsAgree();
      data.caIsAgree = caIsAgree;
      if (!caIsAgree) {
        var url = await globalProperties.$api.webCaApply(`${window.location.origin}/matchweb/layout/auth`);
        // data.agreementUrl = url.agreementUrl;
        window.open(url.agreementUrl, "_self");
      }
    };
    return {
      mainStore,
      data,
      changeTabs
    };
  }
};